export default __webpack_public_path__ + "static/media/budget.75e84ac7.png";